// CallToAction.jsx
"use client";

import React from "react";
import { usePathname, useRouter } from "next/navigation";
import { Button } from "@heroui/button";
import { useSession } from "next-auth/react";
import Link from "next/link";

function Teaser() {
  const router = useRouter(); // Use useRouter to get the router object
  const pathname = usePathname(); // Using usePathname to get the current pathname
  const { data: session, status } = useSession();

  console.log(`Session status: ${status}`); // Check the session status

  const handleSubscribeClick = () => {
    console.log("Subscribe button clicked"); // Confirm the button click
    if (status === "unauthenticated") {
      console.log(`Current path: ${router.asPath}`); // Check the current path
      sessionStorage.setItem("redirectPath", router.asPath);
      router.push("/sign-up");
    } else {
      // Handle the subscription logic for authenticated users
    }
  };

  const handleSignInClick = () => {
    console.log("Sign In button clicked");
    if (status === "unauthenticated") {
      // Set a flag to indicate the user is coming from the banner
      sessionStorage.setItem("fromBanner", "true");
      // Save the current path to redirect back to after signing in
      sessionStorage.setItem("redirectPath", pathname);
      router.push("/sign-in");
    } else {
      router.push("/account");
    }
  };
  // If the user is not authenticated, show the call to action
  if (status === "unauthenticated") {
    return (
      <div className="container sm:h-300 md:h-300 h-400 mb-10 flex flex-col items-center justify-center p-5 hover: shadow-lg bg-1A2C45 rounded-md ">
        <div className="flex space-x-5">
          <p className=" text-E6E6E6 font-light text-small">
            Already a subscriber?
          </p>
          {/* Additional content goes here */}
          <Button
            className="bg-E6E6E6 text-black"
            onClick={handleSignInClick}
            variant="solid"
            size="sm"
          >
            Sign In
          </Button>
        </div>

        <h2 className="text-3xl text-center text-E6E6E6 font-bold">
          Want to read more? Join us for free!
        </h2>
        <p className="text-center font-light text-E6E6E6">
          Explore the latest trends in mining, basic metals, precious metals,
          covered companies, crypto and AI stocks with our Analysts&lsquo; Ideas
          of the Week.
        </p>
        <div className="flex space-x-5">
          <Link href="/plans">
            <Button
              className=" bg-1B51CA text-white"
              color="primary"
              size="default"
            >
              Subscribe for Free
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  // If the user is authenticated, you might want to show a different call to action or none at all
  return null;
}

export default Teaser;
